// Vue.use(VueRouter);
import { createWebHistory, createRouter } from "vue-router";

const routes = [
	{
		path: "/",
		name: "home",
		component: () => import("./views/Home.vue"),
	},
	{
		path: "/auth/:token",
		name: "trainee-auth",
		component: () => import("./views/Auth.vue"),
	},
	{
		path: "/login",
		name: "login",
		component: () => import("./views/Login.vue"),
	},
	{
		path: "/learning",
		name: "learning",
		component: () => import("./views/Learning.vue"),
	},
	{
		path: "/replay/:chapterId",
		name: "replay",
		component: () => import("./views/Replay.vue"),
	},
	{
		path: "/summary",
		name: "summary",
		component: () => import("./views/Summary.vue"),
	},
	{
		path: "/final-quiz",
		name: "final-quiz",
		component: () => import("./views/FinalQuiz.vue"),
	},
	{
		path: "/bravo",
		name: "bravo",
		component: () => import("./views/Bravo.vue"),
	},
	{
		path: "/expired",
		name: "expired",
		component: () => import("./views/Expired.vue"),
	},
	{
		path: "/cancelled",
		name: "cancelled",
		component: () => import("./views/Cancelled.vue"),
	},
	{
		path: "/mobile-disabled",
		name: "mobile-disabled",
		component: () => import("./views/NoMobile.vue"),
	},
	{
		path: "/initial-evaluation",
		name: "initial-evaluation",
		component: () => import("./views/InitialEvaluation.vue"),
	},
	{
		path: "/micro-learning/:token",
		name: "micro-learning",
		component: () => import("./views/MicroLearning.vue"),
	},
	{
		path: "/classroom/:token",
		name: "classroom",
		component: () => import("./views/Classroom.vue"),
	},
	{
		path: "/feedback/:token/:trainingId",
		name: "feedback",
		component: () => import("./views/Feedback.vue"),
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;
